/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Actions_Done_CloseInputs */



/**
* | output |
* | --- |
* | "Close" |
*
* @param {Meeting_Prep_Actions_Done_CloseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_close = /** @type {((inputs?: Meeting_Prep_Actions_Done_CloseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_CloseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sluiten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	return /** @type {LocalizedString} */ ("Close")
});